import { StationeryProductVariantGroup } from '@shared/utils/print-price/types';
import { useGetAttributeDataForSelector } from '../../components/hooks/getAttributeDataForSelector';
import { ProductAttributeSelectorProps } from '../../config.types';

type SelectorData = ReturnType<typeof useGetAttributeDataForSelector>;

export const setAttributeStateWithValidation = (props: ProductAttributeSelectorProps, data: SelectorData, attributeId: string, value: string) => {
  const { getFullState, product, priceCalculator } = props;

  if (!data) {
    throw new Error('SelectorData not provided for setAttributeStateWithValidation');
  }

  const validate = (optionId: string) => {
    const change = {
      attributeId,
      optionId: optionId,
    };
    const isValid = priceCalculator.doesSelectionCreateValidVariantGroup(product.id, getFullState(data.draftData), change);
    return isValid;
  };

  const transformIntoVariantGroup = (group: StationeryProductVariantGroup) => {
    const { options } = group;
    options.forEach(option => {
      const { attributeId, id } = option;
      const targetAttribute = data.otherAttributeStates.find(attrState => attrState.id === attributeId);
      targetAttribute?.state.setOptionId(id);
    });
  };

  const isValid = validate(value);
  if (!isValid) {
    const nextBestVariantGroup = priceCalculator.getBestVariantGroupForChange(product.id, { attributeId, optionId: value });
    if (nextBestVariantGroup) {
      transformIntoVariantGroup(nextBestVariantGroup!);
    } else {
      return false;
    }
  }

  data.state.setOptionId(value!);
  return true;
};
